export default __webpack_public_path__ + "static/media/so.d9e1e4ff.jpg";